"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intakeData_1 = __importDefault(require("../MockData/intakeData"));
const inDateRange_1 = __importDefault(require("../../../Util/inDateRange"));
const Range_1 = __importDefault(require("../../../Util/Range"));
const exception_1 = require("@almservices-cl/exception");
class CustomerList {
    constructor(tokenService, customerRepository, userRepository, customerPeriodRepository, customerNotifications, dateTimeProvider) {
        this.getCustomers = async () => {
            await this.userRepository.getUserByToken(await this.tokenService.getValidToken());
            return this.customerRepository.getCustomers();
        };
        this.markCustomerAsRead = async (customerId) => this.customerNotifications.clearCustomerNotifications(customerId);
        this.changeCoachingDay = async (customer, coachingDays) => {
            await this.userRepository.getUserByToken(await this.tokenService.getValidToken());
            const customers = await this.customerRepository.getCustomers();
            const dbCustomer = customers.find(({ id }) => id === customer.id);
            if (dbCustomer) {
                dbCustomer.subscriptionPeriod.coachingDays = coachingDays;
            }
            await this.customerRepository.updateCustomers(customers);
            const periods = await this.customerPeriodRepository.getPeriods(customer.id);
            const period = periods.find((p) => (0, inDateRange_1.default)(this.dateTimeProvider.currentDate(), new Range_1.default(p.start, p.end)));
            if (period) {
                period.coachingDays = coachingDays;
            }
            return this.customerPeriodRepository.setPeriods(customer.id, periods);
        };
        this.getCustomerSubscriptions = async (customerId) => {
            var _a;
            const periods = await this.customerPeriodRepository.getPeriods(customerId);
            return {
                currentSubscriptionId: (_a = periods.find((p) => (0, inDateRange_1.default)(this.dateTimeProvider.currentDate(), new Range_1.default(p.start, p.end)))) === null || _a === void 0 ? void 0 : _a.subscriptionId,
                subscriptions: periods,
            };
        };
        this.dateTimeProvider = dateTimeProvider;
        this.tokenService = tokenService;
        this.customerRepository = customerRepository;
        this.userRepository = userRepository;
        this.customerPeriodRepository = customerPeriodRepository;
        this.customerNotifications = customerNotifications;
    }
    async getCustomer(customerId) {
        const customers = await this.getCustomers();
        const customer = customers.find(({ id }) => id === customerId);
        if (customer === undefined) {
            throw new exception_1.OutOfRangeException("Customer was not found");
        }
        return customer;
    }
    async getLatestIntakeInfo(customer) {
        if (customer.id === "2") {
            return {
                ...intakeData_1.default,
                questions: intakeData_1.default.questions.filter((question) => question.answer === null),
                xQuestions: intakeData_1.default.xQuestions.filter((question) => question.question === null),
            };
        }
        return intakeData_1.default;
    }
}
exports.default = CustomerList;
//# sourceMappingURL=CustomerList.js.map